module.exports = __webpack_public_path__ + "static/stitch-hire-8d72601af0ec16196261cdb9ca7dafd2.jpg";